type WrongRoute = string;
type CorrectRoute = string;

const REDIRECT_LIST: Record<WrongRoute, CorrectRoute> = {
  '/info/cookies': '/info/kolacici',
  '/en/info/kolacici': '/en/info/cookies',
  '/info/contact': '/info/kontakt',
  '/en/info/kontakt': '/en/info/contact',
  '/info/terms-of-use': '/info/uvjeti-koristenja',
  '/en/info/uvjeti-koristenja': '/en/info/terms-of-use',
  '/info/privacy-policy': '/info/pravila-privatnosti',
  '/en/info/pravila-privatnosti': '/en/info/privacy-policy',
};

/**
 * This makes language switching on 'pages/info/[slug] work correctly
 * We can't do it using 'locale/pages.ts' since we don't have the names of the pages in advance
 * Also - different languages have different slugs
 * All is handled by the info/[slug].vue
 */

export default defineNuxtRouteMiddleware(async (to) => {
  if (Object.keys(REDIRECT_LIST).includes(to.path)) {
    return navigateTo(REDIRECT_LIST[to.path]);
  }
});
